import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Header from "components/Headers/Header";
import { FaComment } from "react-icons/fa";
import Cookies from "universal-cookie";
import VerComentarios from "views/examples/InfoComentarios";
const CreaComentarios = (props) => {
  const cookie = new Cookies();

  const [postNombre, setPostNombre] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaComentarios",
      data: {
        ordenId: props.OrdenId,
        comentario: postNombre,
        usuarioId: cookie.get("id"),
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(" creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  return (
    <>
      <button
        className="btn btn-primary btn-lg"
        onClick={handleOpenModalTest}
        title="Comentarios"
        style={{ border: "2px solid #0085CA" }}
      >
        <FaComment style={{ marginRight: "0px" }} />
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col className="text-right" xs="4"></Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br> <br></br>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      Comentarios
                    </h6>
                    {/* Description */}
                    <div className="pl-lg-4">
                      <FormGroup>
                        <Input
                          className="form-control-alternative"
                          id="input-postal-code"
                          placeholder=""
                          type="textarea"
                          onChange={(e) => setPostNombre(e.target.value)}
                        />
                      </FormGroup>
                      <button
                        className="btn btn-primary btn-lg"
                        color="primary"
                        onClick={postData}
                      >
                        ENVIAR
                      </button>
                    </div>
                    <div></div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <VerComentarios id={props.OrdenId} />
      </ReactModal>
    </>
  );
};

export default CreaComentarios;
